export const URLS = {
  CONTACT: "mailto:info@imajine.one",
} as const;

type CurriculumIconKey = "book" | "users" | "target";

type CurriculumItem = {
  session: string;
  title: string;
  description: string;
  note?: string;
  structure: string;
  duration: string;
  icon: CurriculumIconKey;
};

type ContentProfileKey = "fiveSession" | "twoSession" | "tiktokFiveSession" | "instagramFiveSession";

type ContentProfile = {
  trainingName: string;
  heroDescription: string;
  curriculumLead: string;
  programOverview: string;
  backgroundLead: string;
  programStats: {
    MAX_SUBSIDY_RATE: string;
    MIN_COST_PER_PERSON: string;
    TOTAL_HOURS: string;
    TOTAL_SESSIONS: string;
  };
  curriculum: {
    items: CurriculumItem[];
    totalHours: string;
  };
  flow: {
    executionDescription: string;
  };
  applicationFlow: {
    completionTimeline: string;
  };
};

const CONTENT_PROFILES: Record<ContentProfileKey, ContentProfile> = {
  fiveSession: {
    trainingName: "AI研修プログラム",
    heroDescription:
      "厚生労働省の「人材開発支援助成金（リスキリング支援コース）」を活用し、低コストで効果的な社員のAI・DXスキル向上を実現します。",
    curriculumLead: "基礎から実践まで、段階的にAI活用スキルを習得できる体系的なカリキュラム",
    programOverview: "実践的なAI・DXスキル習得を目指す、包括的な人材育成プログラム",
    backgroundLead:
      "AI・デジタル技術の急速な進化により、企業には業務の効率化と高度化が求められています。中小企業がこれに対応するためには、社員一人ひとりのAIリテラシー向上=DX人材化が必要です。",
    programStats: {
      MAX_SUBSIDY_RATE: "75%",
      MIN_COST_PER_PERSON: "10万円〜",
      TOTAL_HOURS: "10時間",
      TOTAL_SESSIONS: "全5回",
    },
    curriculum: {
      items: [
        {
          session: "第1回",
          title: "生成AIの基礎知識",
          description:
            "生成AIの概要、生成AIの最新事情、ChatGPTの基本、画像生成AIの基本、プロンプトの学習",
          note: "",
          structure: "座学中心",
          duration: "2時間",
          icon: "book",
        },
        {
          session: "第2回",
          title: "AI倫理とChatGPT実戦",
          description: "AI倫理について、実戦パート(ChatGPT編セット)",
          note: "",
          structure: "座学 + 実習",
          duration: "2時間",
          icon: "target",
        },
        {
          session: "第3回",
          title: "実践的なAI活用",
          description:
            "実践パート(実際に使ってみよう)、実践パート(業務効率化)、実践パート(プロンプト生成練習①)",
          note: "",
          structure: "実習中心",
          duration: "2時間",
          icon: "users",
        },
        {
          session: "第4回",
          title: "プロンプト技術と画像認識",
          description: "実践パート(プロンプト生成練習②)、実践パート(画像認知機能)",
          note: "",
          structure: "実習中心",
          duration: "2時間",
          icon: "target",
        },
        {
          session: "第5回",
          title: "画像生成とAI活用応用",
          description: "実践パート(画像生成)、AI活用法(応用編)",
          note: "",
          structure: "実習中心",
          duration: "2時間",
          icon: "users",
        },
      ],
      totalHours: "10時間",
    },
    flow: {
      executionDescription: "座学＋ワークショップ形式で、全5回・10時間の実践的な研修を提供します。",
    },
    applicationFlow: {
      completionTimeline: "全5回完了",
    },
  },
  twoSession: {
    trainingName: "AI研修プログラム",
    heroDescription:
      "厚生労働省の「人材開発支援助成金（リスキリング支援コース）」を活用し、低コストで効果的な社員のAI・DXスキル向上を実現します。",
    curriculumLead: "基礎から実践まで、段階的にAI活用スキルを習得できる体系的なカリキュラム",
    programOverview: "実践的なAI・DXスキル習得を目指す、包括的な人材育成プログラム",
    backgroundLead:
      "AI・デジタル技術の急速な進化により、企業には業務の効率化と高度化が求められています。中小企業がこれに対応するためには、社員一人ひとりのAIリテラシー向上=DX人材化が必要です。",
    programStats: {
      MAX_SUBSIDY_RATE: "75%",
      MIN_COST_PER_PERSON: "10万円〜",
      TOTAL_HOURS: "10時間",
      TOTAL_SESSIONS: "全2回",
    },
    curriculum: {
      items: [
        {
          session: "第1回",
          title: "生成AI基礎とセットアップ",
          description:
            "生成AIの概要（10分）、生成AIの最新事情（10分）、ChatGPTの基本（10分）、画像生成AIの基本（10分）、プロンプトの学習（20分）、AI倫理（10分）と世界動向（10分）、実戦パート: ChatGPTセットアップ（60分）、実践: 使ってみよう（80分）、実践: 業務効率化（80分）",
          note: "",
          structure: "座学＋実習",
          duration: "5時間（300分）",
          icon: "book",
        },
        {
          session: "第2回",
          title: "プロンプト応用と画像活用",
          description:
            "実践: プロンプト生成練習①（60分）、実践: プロンプト生成練習②（60分）、実践: 画像認知機能（60分）、実践: 画像生成（60分）、AI活用法（応用編）（60分）",
          note: "",
          structure: "実習中心",
          duration: "5時間（300分）",
          icon: "target",
        },
      ],
      totalHours: "10時間",
    },
    flow: {
      executionDescription: "座学＋ワークショップ形式で、全2回・10時間の実践的な研修を提供します。",
    },
    applicationFlow: {
      completionTimeline: "全2回完了",
    },
  },
  tiktokFiveSession: {
    trainingName: "TikTok研修プログラム",
    heroDescription:
      "短編動画の企画・撮影・編集・配信まで、TikTok運用に必要なスキルを10時間で習得。公式アカウントの立ち上げから広告・エンゲージメント強化まで実践的に学べます。",
    curriculumLead:
      "基礎運用から広告・オリジナル動画制作まで、TikTokスキルを段階的に習得するカリキュラム",
    programOverview: "TikTok公式アカウントを内製で立ち上げ、継続運用できるようになる実践プログラム",
    backgroundLead:
      "短編動画が主戦場となる今、TikTok運用はブランド認知や採用まで企業成長の鍵となっています。運用を内製化することで継続的に成果を出しやすい体制をつくれます。",
    programStats: {
      MAX_SUBSIDY_RATE: "75%",
      MIN_COST_PER_PERSON: "10万円〜",
      TOTAL_HOURS: "10時間",
      TOTAL_SESSIONS: "全5回",
    },
    curriculum: {
      items: [
        {
          session: "第1回【2時間】",
          title: "TikTokの基本と初級クリエイティブ",
          description:
            "TikTokの基本（10分）、プロフィール作成とカスタマイズ（30分）、動画の作成（初級編）（60分）、コンテンツの配信（10分）、コミュニティとのエンゲージメント・分析（10分）",
          note: "",
          structure: "座学＋実習",
          duration: "2時間",
          icon: "book",
        },
        {
          session: "第2回【2時間】",
          title: "広告・マネタイズと中級動画制作",
          description: "広告とマネタイズ（10分）、ガイドライン（10分）、ケーススタディ（10分）、動画作成（中級編）（90分）",
          note: "",
          structure: "座学＋実習",
          duration: "2時間",
          icon: "target",
        },
        {
          session: "第3回【2時間】",
          title: "上級動画制作とベンチマーク",
          description: "動画作成（上級編）（90分）、00を真似てみよう！（30分）",
          note: "",
          structure: "実習中心",
          duration: "2時間",
          icon: "users",
        },
        {
          session: "第4回【2時間】",
          title: "オリジナル制作ワーク①",
          description: "00を真似てみよう！（60分）、オリジナルを作ってみよう！（60分）",
          note: "",
          structure: "実習中心",
          duration: "2時間",
          icon: "target",
        },
        {
          session: "第5回【2時間】",
          title: "オリジナル制作ワーク②とトレンド",
          description:
            "オリジナルを作ってみよう！（50分）、完全オリジナルを作ってみよう！（60分）、未来のTikTokとトレンド（10分）",
          note: "",
          structure: "実習中心",
          duration: "2時間",
          icon: "users",
        },
      ],
      totalHours: "10時間",
    },
    flow: {
      executionDescription: "座学＋ワークショップ形式で、全5回・10時間でTikTok運用と動画制作を実践的に学びます。",
    },
    applicationFlow: {
      completionTimeline: "全5回完了",
    },
  },
  instagramFiveSession: {
    trainingName: "Instagram研修プログラム",
    heroDescription:
      "Instagram運用に必要な企画・制作・分析スキルを10時間で習得。公式アカウント設計から投稿・リール制作まで実践的に学べます。",
    curriculumLead:
      "プロフィール設計からフィード・リール制作、インサイト分析まで、Instagram運用の必須スキルを段階的に習得します。",
    programOverview: "ブランド発信を強化し、内製で継続的に運用できるようになる実践プログラム",
    backgroundLead:
      "ビジュアルコミュニケーションが重視される今、Instagramは認知から採用・販促まで多様なシーンで重要です。運用スキルを内製化し、継続的に成果を出す体制づくりが求められます。",
    programStats: {
      MAX_SUBSIDY_RATE: "75%",
      MIN_COST_PER_PERSON: "10万円〜",
      TOTAL_HOURS: "10時間",
      TOTAL_SESSIONS: "全5回",
    },
    curriculum: {
      items: [
        {
          session: "第1回【2時間】",
          title: "Instagram基礎とプロフィール設計",
          description:
            "SNSマーケティングの基本（15分）、Instagramの役割（15分）、プロフィールの作成とカスタマイズ（90分）",
          note: "",
          structure: "座学＋実習",
          duration: "2時間",
          icon: "book",
        },
        {
          session: "第2回【2時間】",
          title: "クリエイティブ制作とアカウント設計",
          description: "Canvaを使って画像を作成（90分）、アカウントの設計を考える（30分）",
          note: "",
          structure: "実習中心",
          duration: "2時間",
          icon: "target",
        },
        {
          session: "第3回【2時間】",
          title: "アルゴリズムとストーリーズ実践",
          description: "アルゴリズムの理解（10分）、インサイト分析（10分）、ガイドライン（10分）、ストーリー作成（90分）",
          note: "",
          structure: "座学＋実習",
          duration: "2時間",
          icon: "users",
        },
        {
          session: "第4回【2時間】",
          title: "フィード投稿とテーマ設計",
          description: "ハイライト作成（40分）、投稿テーマ設計（20分）、フィード投稿（オリジナル）作成（60分）",
          note: "",
          structure: "実習中心",
          duration: "2時間",
          icon: "target",
        },
        {
          session: "第5回【2時間】",
          title: "投稿運用とリール制作",
          description:
            "投稿とキャプション・ハッシュタグ設計（40分）、リール動画作成（60分）、成功アカウント事例（10分）、未来のInstagramとトレンド（10分）",
          note: "",
          structure: "実習中心",
          duration: "2時間",
          icon: "users",
        },
      ],
      totalHours: "10時間",
    },
    flow: {
      executionDescription: "座学＋ワークショップ形式で、全5回・10時間でInstagram運用とクリエイティブ制作を実践的に学びます。",
    },
    applicationFlow: {
      completionTimeline: "全5回完了",
    },
  },
};

const MODE_PROFILE_MAP: Record<string, ContentProfileKey> = {
  twoSession: "twoSession",
  "2sessions": "twoSession",
  fiveSession: "fiveSession",
  "5sessions": "fiveSession",
  tiktokFiveSession: "tiktokFiveSession",
  "tiktok-5": "tiktokFiveSession",
  instagramFiveSession: "instagramFiveSession",
  "instagram-5": "instagramFiveSession",
  production: "twoSession",
};

const modeKey = import.meta.env.MODE;
const envProfile = import.meta.env.VITE_CONTENT_PROFILE as ContentProfileKey | undefined;
const profileKey = envProfile ?? MODE_PROFILE_MAP[modeKey] ?? "twoSession";
const selectedProfile = CONTENT_PROFILES[profileKey] ?? CONTENT_PROFILES.twoSession;

export const CONTENT_PROFILE = profileKey;
export const PROGRAM_STATS = selectedProfile.programStats;
export const CURRICULUM_ITEMS = selectedProfile.curriculum.items;
export const CURRICULUM_TOTAL_HOURS = selectedProfile.curriculum.totalHours;
export const FLOW_EXECUTION_DESCRIPTION = selectedProfile.flow.executionDescription;
export const APPLICATION_COMPLETION_TIMELINE = selectedProfile.applicationFlow.completionTimeline;
export const TRAINING_NAME = selectedProfile.trainingName;
export const HERO_DESCRIPTION = selectedProfile.heroDescription;
export const CURRICULUM_LEAD = selectedProfile.curriculumLead;
export const PROGRAM_OVERVIEW = selectedProfile.programOverview;
export const BACKGROUND_LEAD = selectedProfile.backgroundLead;

export const COMPANY_INFO = {
  NAME: "合同会社イマジン",
  PROGRAM_NAME: "AI/DX人材育成プログラム",
} as const;
